import {i18n} from '@/plugins/i18n'
import {subjectTypeStr, subjectTypes} from '@/constants/UsersClubSubjectTypes'
import DescriptionColumn from './../components/description-column'

const descriptionTemplate = (row, index, datatable) => {
    let template = new DescriptionColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

export default [
    {
        field: 'id',
        width: 60,
        title: i18n.t('customers_club.event_id'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'username',
        width: 60,
        title: i18n.t('label.username'),
        template: (row) => {
            return '<a href="/users/' + row.user_id + '/details">' + row.username + '</a>'
        },
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'subject',
        width: 80,
        title: i18n.t('customers_club.change_subject'),
        template: (row) => {
            let subject = subjectTypeStr.get(row.subject)
            let variant = 'badge badge-light'
            if (row.subject === subjectTypes.LEVEL_CHANGE)
                variant = 'badge badge-success'
            if (row.subject === subjectTypes.WAGE_CHANGE)
                variant = 'badge badge-primary'
            return '<div class="' + variant + ' text-black">' + subject + '</div>'
        },
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'description',
        width: 80,
        title: i18n.t('label.description'),
        template: (row, index, datatable) => {
            return descriptionTemplate(row, index, datatable)
        },
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.date_created'),
        sortable: true,
        textAlign: 'center',
    },
]
